import type { SubMenuProps as AntSubMenuProps } from 'antd';
import React from 'react';
import { StyledSubMenu } from './styled';

export interface SubMenuProps extends AntSubMenuProps {
  className?: string;
}

const DIME_SUBMENU_POPUP_CLASS = 'dime-menu-submenu-popup';

export const SubMenu: React.FC<SubMenuProps> = ({
  className = '',
  popupClassName,
  ...props
}) => {
  return (
    <StyledSubMenu
      className={className}
      popupClassName={
        popupClassName
          ? `${DIME_SUBMENU_POPUP_CLASS} ${popupClassName}`
          : DIME_SUBMENU_POPUP_CLASS
      }
      {...props}
    />
  );
};

